import { render } from "./Foot.vue?vue&type=template&id=5ad73af5&scoped=true"
const script = {}

import "./Foot.vue?vue&type=style&index=0&id=5ad73af5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad73af5"]])

export default __exports__